module.exports = __webpack_public_path__ + "img/costa-rica.daf53921.png";